import logo from './logo.svg'

export const GoodlordReferencingLogo = () => {
  return <img src={logo} alt="" />
}
